import { Http, Url } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getInvoices({ commit, state }) {
    commit('toggleLoadingInvoices', true);

    const { created, due_date, ...filters } = state.filters;

    const params = filters;

    if (created) {
      Object.assign(params, {
        createdStart: created.start,
        createdEnd: created.end,
      });
    }

    if (due_date) {
      Object.assign(params, {
        dueDateStart: due_date.start,
        dueDateEnd: due_date.end,
      });
    }

    return Http.get(Url.toQueryString('audit/v1/invoices', params)).then((res) => {
      commit('setTotalInvoices', res.headers['x-total-count'] || res.data.length);
      commit('invoices', res.data);
      commit('toggleLoadingInvoices', false);
    }).catch(() => {
      commit('toggleLoadingInvoices', false);
    });
  },
  getInvoice({ commit }, invoiceId) {
    commit('toggleLoadingInvoice', true);
    commit('invoice', null);

    return Http.get(`audit/v1/invoices/${invoiceId}/result/summary`).then((res) => {
      commit('invoice', res.data);
      commit('toggleLoadingInvoice', false);
    }).catch(() => {
      commit('toggleLoadingInvoice', false);
    });
  },
  getInvoiceMarkers({ commit }, invoiceId) {
    return Http.get(`audit/v1/invoices/${invoiceId}/markers`)
      .then(res => commit('invoiceMarkers', res.data));
  },
  getInvoiceHistory({ commit }, invoiceId) {
    commit('toggleLoadingInvoiceHistory', true);

    return Http.get(`audit/v1/invoices/${invoiceId}/histories`).then((res) => {
      commit('invoiceHistory', res.data);
      commit('toggleLoadingInvoiceHistory', false);
    }).catch(() => {
      commit('toggleLoadingInvoiceHistory', false);
    });
  },
  getInvoiceOrderItems({ commit, state }, invoiceId) {
    commit('toggleLoadingInvoiceOrderItems', true);

    return Http.get(Url.toQueryString(`audit/v1/invoices/${invoiceId}/result/items`, state.invoiceOrderItemsPagination)).then((res) => {
      commit('setTotalInvoiceOrderItems', res.headers['x-total-count'] || res.data.length);
      commit('invoiceOrderItems', res.data);
      commit('toggleLoadingInvoiceOrderItems', false);
    }).catch(() => {
      commit('toggleLoadingInvoiceOrderItems', false);
    });
  },
  createInvoice({ commit }, invoice) {
    const {
      logisticProviderId,
      deliveryMethodId,
      dueDate,
      invoiceFiles,
      ctesFiles,
    } = invoice;

    const formData = new FormData();
    formData.append('logisticProviderId', logisticProviderId);

    if (deliveryMethodId) {
      formData.append('deliveryMethodId', deliveryMethodId);
    }

    if (invoiceFiles && invoiceFiles.file) {
      formData.append('files[0]', invoiceFiles.file);
    }

    if (ctesFiles && ctesFiles.file) {
      formData.append('files[1]', ctesFiles.file);
    }

    if (dueDate) {
      formData.append('dueDate', new Date(dueDate).getTime());
    }

    commit('setLoadingInvoiceForm', true);

    return Http.post('audit/v1/invoices', formData)
      .then((res) => {
        Promise.resolve(ScToast.success('Fatura criada com sucesso'));
        commit('setLoadingInvoiceForm', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('setLoadingInvoiceForm', false);
        return Promise.reject(err);
      });
  },
  downloadInvoiceFilePerUrl({ commit }, url) {
    commit('toggleLoadingInvoices', true);

    return Http.get(url).then((res) => {
      commit('toggleLoadingInvoices', false);
      window.open(res.data.url, '_black');

      return Promise.resolve(res);
    });
  },
  generateAnalyzeFile(context, invoiceId) {
    return Http.post(`audit/v1/invoices/${invoiceId}/result`)
      .then(() => ScToast.success(
        'O arquivo está sendo gerado, em instantes o mesmo estará disponível na seção Meus Arquivos.',
      ));
  },
  linkMarker({ state, dispatch }, markerId) {
    const invoiceId = state.invoice.reconciliation_invoice_id;

    return Http.post(`audit/v1/invoices/${invoiceId}/markers/${markerId}`)
      .then(() => dispatch('getInvoiceMarkers', invoiceId))
      .then(() => ScToast.success('Marcador vinculado com sucesso'));
  },
  unlinkMarker({ state, dispatch }, markerId) {
    const invoiceId = state.invoice.reconciliation_invoice_id;

    return Http.delete(`audit/v1/invoices/${invoiceId}/markers/${markerId}`)
      .then(() => dispatch('getInvoiceMarkers', invoiceId))
      .then(() => ScToast.success('Marcador desvinculado com sucesso'));
  },
  changeState({ state, dispatch }, newState) {
    const { reconciliation_invoice_id } = state.invoice;

    return Http.patch(`audit/v1/invoices/${reconciliation_invoice_id}`, {
      fields: [
        {
          name: 'state',
          value: newState,
        },
      ],
    })
      .then(() => dispatch('getInvoice', reconciliation_invoice_id))
      .then(() => dispatch('getInvoiceHistory', reconciliation_invoice_id))
      .then(() => ScToast.success('Status atualizado com sucesso'));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/store/actions.js